export default {"src":"/_next/static/media/Lord-badge.9bb8937c.svg","height":46,"width":46};